// data/items/arrowheads.js
// Arrow head items for woodworking ammunition

export const ARROWHEADS = [
    {
        id: 'pyrestone_arrowheads',
        name: 'Pyrestone Arrowheads',
        color: '#cd7f32',
        value: 8,
        sprite: { sheet: 'assets/icons/woodworking/pyrestone_arrowhead.png', x: 0, y: 0, width: 64, height: 64 }
    },
    {
        id: 'pale_shard_arrowheads',
        name: 'Pale Shard Arrowheads',
        color: '#c0c0c0',
        value: 18,
        sprite: { sheet: 'assets/icons/woodworking/pale_shard_arrowhead.png', x: 0, y: 0, width: 64, height: 64 }
    },
    {
        id: 'blackiron_arrowheads',
        name: 'Blackiron Arrowheads',
        color: '#2d2d2d',
        value: 32,
        sprite: { sheet: 'assets/icons/woodworking/blackiron_arrowhead.png', x: 0, y: 0, width: 64, height: 64 }
    },
    {
        id: 'skyiron_arrowheads',
        name: 'Skyiron Arrowheads',
        color: '#4169e1',
        value: 50,
        sprite: { sheet: 'assets/icons/woodworking/skyiron_arrowhead.png', x: 0, y: 0, width: 64, height: 64 }
    },
    {
        id: 'verdant_core_arrowheads',
        name: 'Verdant Core Arrowheads',
        color: '#228b22',
        value: 75,
        sprite: { sheet: 'assets/icons/woodworking/verdant_core_arrowhead.png', x: 0, y: 0, width: 64, height: 64 }
    },
    {
        id: 'voidsteel_arrowheads',
        name: 'Voidsteel Arrowheads',
        color: '#00ced1',
        value: 105,
        sprite: { sheet: 'assets/icons/woodworking/voidsteel_arrowhead.png', x: 0, y: 0, width: 64, height: 64 }
    }
];

export default ARROWHEADS;
